import { z } from 'zod';
import { jArticleListSchema } from './article';
import { filtersSchema, ordersSchema } from './utils';

export enum ContentReportStatus {
    RUNNING = 'running',
    CLOSED = 'closed',
    HANDLED = 'handled',
}

export const contentReportListSchema = jArticleListSchema.extend({
    articleId: z.number(),
    articleType: z.string(),
    articleTitle: z.string(),
    articleUrl: z.string(),
    commentId: z.number().optional(),
    commentType: z.string().optional(),
    status: z.nativeEnum(ContentReportStatus),
});
export type ContentReportList = z.infer<typeof contentReportListSchema>;

export const getReportsParamsSchema = z.object({
    limit: z.number().optional(),
    page: z.number().optional(),
    orders: ordersSchema.optional(),
    filters: filtersSchema.optional(),
});
export type GetReportsParams = z.infer<typeof getReportsParamsSchema>;

export const createReportParamsSchema = z.object({
    uri: z.string(),
    description: z.string(),
});
export type CreateReportParams = z.infer<typeof createReportParamsSchema>;

export const updateReportStatusParamsSchema = z.object({
    uri: z.string(),
    status: z.nativeEnum(ContentReportStatus),
});
export type UpdateReportStatusParams = z.infer<typeof updateReportStatusParamsSchema>;
